import React from 'react';
import NRCB_ICAR_image from '../../assets/Logo/NRCB_ICAR.jpg';

function AboutUS() {
  const aboutData = [
    {
      description:
        'was established on 21st August 1993 at Tiruchirappalli, Tamil Nadu by ICAR, New Delhi with an aim to increase the production and productivity of banana and plantains through mission mode basic and strategic research approaches. The Centre works on four major thrust areas of research viz., Crop Improvement, Crop Production, Post Harvest Management, and Crop Protection. It has well-equipped laboratories for tissue-culture, bio-technology, soil science, nutrient management, physiology, biochemistry, entomology, nematology, fungal, bacterial, viral pathology, and post-harvest technology research.In the late nineties, 10 collection surveys through explorations were made. Wild banana germplasm from the North-Eastern states, Western Ghats, and Andaman & Nicobar Islands and also exotic banana accessions from International Transit Centre (ITC), Belgium through NBPGR, New Delhi were introduced. The Centre has completed seven in-house research projects and eleven are in progress in the 11th five-year plan. In addition to Centre’s in-house projects, 26 externally funded projects by AP Cess fund of ICAR, NATP, DBT, NHB, and INIBAP were completed. The Perspective Plan and Vision 2030 documents on the research priorities and also inputs from the QRT and RAC were published. The Centre conducts two meetings of the Institute Research Council to review the ongoing research projects and also to incorporate the RAC recommendations.The vision of the centre is to increase the production and productivity of bananas and plantains to meet the growing need in India.',
      image: NRCB_ICAR_image,
    },
  ];
  return (
    <div className='container  my-5'>
      <div className='row d-flex align-items-center justify-content-center mb-4'>
        <div className='col-12 d-flex justify-content-center'>
          <h3 className='underline'>About Us</h3>
        </div>
        <div className='col-md-12 col-sm-12'>
          <img
            src={aboutData[0].image}
            alt='About Us'
            style={{ width: '100%', height: 'auto', padding: '10px' }}
          />
        </div>
        <div className='col-md-12 col-sm-12 mt-4'>
          <p style={{ textAlign: 'justify' }}>
            <b>ICAR-National Research Centre for Banana</b>{' '}
            {aboutData[0].description}
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutUS;
